import { Component, OnInit } from '@angular/core';
import { fadeOpacity, fadeAnimation } from 'projects/f-cms/src/app/animations/animations';

@Component({
  selector: 'mm-fab',
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.scss'],
  animations: [fadeOpacity, fadeAnimation]
})
export class FabComponent implements OnInit {

  show: boolean;

  constructor() { }

  ngOnInit() {
  }

}
